// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"Socials_buttonGroup__l7mFZ","optionButton":"Socials_optionButton__el284","apple":"Socials_apple__KlUVL","fb":"Socials_fb__Cpw_0","phone":"Socials_phone__fEy3o"};